import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import ReactPaginate from 'react-paginate'
import _ from 'lodash'

import FilterBar from '../../components/filters/FilterBar'
import LoadingSpinner from '../../components/elements/LoadingSpinner'
import TripCard from '../../components/TripCard/TripCard'

import { useGetFilteredTours } from '../../hooks/useGetFilteredTours'
import { getCardsPerPage } from '../../redux/reducers/configuration'
import { getToursLoading } from '../../redux/reducers/tours'
import '../../styles/scss/views/results-container.scss'
import '../../styles/scss/components/pagination.scss'

const ResultsContainer = () => {
  const loading = useSelector(getToursLoading)
  const tours = useGetFilteredTours()
  const PER_PAGE = useSelector(getCardsPerPage)
  const [currentPage, setCurrentPage] = useState(0)
  const [data, setData] = useState(tours ? tours : [])

  useEffect(() => {
    setCurrentPage(0)
    setData(tours)
  }, [tours])

  const offset = currentPage * PER_PAGE
  const currentPageData =
    _.size(data) > 0 &&
    data.slice(offset, offset + PER_PAGE).map((tour) => {
      return (
        <div
          className="results-container__grid__column"
          key={tour.id}
        >
          <TripCard key={tour.id} trip={tour} />
        </div>
      )
    })

  const pageCount = _.size(data) > 0 && Math.ceil(data.length / PER_PAGE)
  const totalTours = _.size(tours)
  const visibleCardsCounts = _.size(data.slice(offset, offset + PER_PAGE))

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage)
    const filterBar  = document.getElementById('ylg__site-search-settings_filter-bar')
    if (filterBar) {
      filterBar.scrollIntoView()
    }
  }

  const visibleCards = Boolean(visibleCardsCounts)
    ? `${offset + 1} - ${offset + visibleCardsCounts}`
    : visibleCardsCounts
  const viewingCountLabel = `Viewing <strong>${visibleCards}</strong> of ${totalTours}`

  return (
    <div className="u-flex u-flex-column results-container">
      <FilterBar />
      {loading && (
        <div>
          <LoadingSpinner />
        </div>
      )}
      {!loading && (
        <>
          <span
            className="results-container__view-count results-container__view-count__header"
            dangerouslySetInnerHTML={{ __html: viewingCountLabel }}
          />
          <div className="u-flex u-flex-wrap results-container__grid">
            {currentPageData}
          </div>

          <div className="u-flex u-flex-align-center u-flex-justify-center u-flex-wrap results-container__pagination-wrapper">
            {_.size(data) > PER_PAGE && (
              <>
                <span
                  className="results-container__view-count results-container__view-count__footer"
                  dangerouslySetInnerHTML={{ __html: viewingCountLabel }}
                />
                <ReactPaginate
                  forcePage={currentPage}
                  marginPagesDisplayed={1}
                  previousLabel=""
                  nextLabel=""
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  previousLinkClassName={'pagination__previous pagination__link'}
                  nextLinkClassName={'pagination__next pagination__link'}
                  disabledClassName={'pagination__link__disabled'}
                  activeClassName={'pagination__link__active'}
                />
              </>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default ResultsContainer
